const Button = ({ name }) => {
  return (
    <div className="bg-neutral-100 my-1 mx-2 py-1 px-2 rounded cursor-pointer">
      {name}
    </div>
  );
};

export default Button;
